<template>
  <div class="hsec">
    <loader v-if="!customHtml"></loader>
    <div class="remoteContent" v-html="customHtml"></div>
    <!--    TODO Remove after testing on production-->
    <div v-if="reservedInfo">
      <div class="row top">
        <div class="col header-text">
          <h1>Referral Program</h1>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row privacy-content">
              <div>
                <p class="text-header">Introduction</p>
                <p class="text">This referral program of Income Company OÜ (hereinafter the “<strong>Referral Program</strong>”) stipulates the terms and conditions applicable to the rewards of benefits
                  offered from time to time for
                  the users of Income marketplace through <a href="//www.getincome.com">www.getincome.com</a>
                  (hereinafter “<strong>Income marketplace</strong>”).
                </p>
                <p class="text">
                  Any capitalised terms used in the Referral Program have the same meaning as in the User Agreement of Income, unless specified otherwise.
                </p>
                <p class="text">
                  The Referral Program is meant for any User to introduce Income marketplace to any of his/her friends, acquaintances, colleagues from the philosophy of “invite a friend” point of view.
                </p>

                <p class="text-header">Availability of Referral Program</p>
                <p class="text">Any existing User may share a referral code or link (hereinafter “<strong>Referral Link</strong>”) to private individuals who have not registered themselves as User in
                  Income marketplace prior to receiving the Referral Link i.e. to new potential investors (e.g. friends, acquaintances, colleagues), but not to the public as general. User’s family
                  members, members of his/her household are specifically excluded from the Referral Program. The same exclusion applies to legal entities where the user or his/her family or member of
                  his/her household is an Ultimate Beneficial Owner (UBO).</p>
                <p class="text">The User may refer an unlimited number of potential new investors and the User has the right to receive the Reward for each referred investor fulfilling the conditions
                  and preconditions of the Referral Program.</p>
                <p class="text">Benefits arising from the Referral Program cannot be used together with any other separate promotion, discount or benefit offered by Income marketplace.</p>

                <p class="text-header">Reward</p>
                <p class="text">If a new investor registers as User in Income marketplace with the Referral Link and makes an investment into Loan(s), then the User who made the Referral Link available
                  to the investor has a right to receive a reward (hereinafter — the <strong>Reward</strong>) based on the outstanding balance of principal invested amount (not counting any possible
                  re-invested amount)
                  during the first 30 days from when the new investor registered as User in Income marketplace (hereinafter the “<strong>Reward Period</strong>”). A Reward will be paid also to the new
                  investor.</p>
                <p class="text">
                  Specific type and monetary amount of Reward may vary from time to time and will be shown at the Referral Program page in Income marketplace.
                </p>
                <p class="text">
                  The Reward is paid in EUR, in one instalment within 10 business days after the Reward Period has ended, by depositing electronic funds equivalent to the Reward into the Virtual Account
                  of the User, if all conditions and preconditions for the Reward as per this Referral Program have been fulfilled and the nor User, nor the referred party were disqualified for any
                  reason from the Referral Program.
                </p>
                <p class="text">
                  The Reward amount shall include all applicable taxes for participation in the Referral Program and respective taxes (if applicable) shall be covered by the User, unless Income has a
                  statutory obligation to withhold the taxes in which case the respective amount shall be deducted from the Reward.
                </p>

                <p class="text-header">Receipt of Reward</p>
                <p class="text">For the User to receive the Reward, the following preconditions must be fulfilled:</p>
                <ul>
                  <li>the User and the referred investor are duly registered Users of Income marketplace and there are no pending information requests to them from Income;</li>
                  <li>referred investor is not the User’s family member or member of User’s household;</li>
                  <li>the referred investor has used the Referral Link shared by the User upon registering as User at Income marketplace;</li>
                  <li>the referred investor may not have had an investor account at Income marketplace before i.e. he/she must be a new investor;</li>
                  <li>the User and the referred investor are both different natural persons;</li>
                  <li>the User and the referred investor have not breached the Referral Program.</li>
                </ul>

                <p class="text-header">Restrictions for referrals</p>
                <p class="text">User may not use, publish, distribute or make otherwise the Referral Link publicly available, incl.:</p>
                <ul>
                  <li>make any kind of commercial activity or paid promotion including online advertising;</li>
                  <li>distribute the Referral Link on any websites what-so-ever, incl. any websites which provide erotic, indecent or deceptive content or gambling or betting services or offer uploading
                    or downloading of any illegal content, any other website which provide reviews or coupons or any rewards for referrals;
                  </li>
                  <li>send or offer Referral Link to any person who the User does not personally know either by emails, text messages or through other means;</li>
                  <li>integrate the Referral Link in browser extensions or using an automated system, script, program, dialler, or bot through any channel;</li>
                  <li>use the Referral Link in any other way which differs from Income’s principles or in any other way that may qualify as an unfair commercial practice, determined by Income’s sole
                    discretion.
                  </li>
                </ul>

                <p class="text-header">Breach of Referral Program</p>
                <p class="text">Income has the right to remove the User from access to the Referral Program indefinitely if the User has referred themselves or any family member or member of their
                  household to Income marketplace as new investor or Income, based on its sole discretion, believes that the User has created an investor account for the primary purpose of collecting
                  the Reward through the Referral Program.</p>
                <p class="text">In case Income discovers that the User is has breached the Referral Program then Income has the right to suspend and terminate at any time any payment of Reward to the
                  User and/or reclaim directly or via set-off of mutual claims any Reward previously paid to the Users.</p>

                <p class="text-header">Limitation of liability</p>
                <p class="text">Income is not liable for any misuse of the Referral Link, including but not limited to, technical issues that might cause the Referral Link to not work properly, thus not
                  appearing as used when the referred party is creating the account on Income marketplace.</p>

                <p class="text-header">Amendments</p>
                <p class="text">Income has the right to amend or terminate the Referral Program any time unilaterally and without prior notice.</p>

                <p class="text-header">Validity</p>
                <p class="text">Referral Program is valid from 5 November 2020 to 31.12.2023, unless amended by Income earlier.</p>
                <p class="text">Legal relations arising from this Referral Program arise to the Users from the Referral Program which was available on Income marketplace at the moment when the referred
                  investor created the investor account with the Referral Link.</p>

                <p class="text-header">Applicable law and resolution of disputes</p>
                <p class="text">Referral Program is governed by and has been constructed in accordance with the laws of Estonia. Any dispute,  controversy  or  claim  arising  under  or  relating  to  the  Referral  Program  are  resolved  in  Harju Country Court (<i>Harju Maakohus</i>) in Tallinn, Estonia.</p>
                <p class="text"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import marketingHelper from '@/helpers/marketingHelper'

export default {
  name: 'Referral program',
  components: {Loader},
  data()
  {
    return {
      customHtml: '',
      reservedInfo: false
    }
  },
  mounted()
  {
    marketingHelper.getMarketingRequest('referral').then((response) =>
    {
      this.customHtml = marketingHelper.parseContent(response)
    }).catch(error =>
    {
      console.log(error)
      this.reservedInfo = true
      this.customHtml = ' '
    })
  }
}
</script>

<style scoped lang="scss">

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  font-weight: bold;
  margin: 52px auto 16px 5%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-repeat: no-repeat;
  background-size: cover;
}

.top-title {
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 100%;
}

.text-header {
  margin: 45px auto 12px 1%;
  font-weight: bold;
}

.underline {
  text-decoration: underline;
}

.text {
  margin-left: 2%;
  text-align: justify;
}

.privacy-content {
  text-align: justify;
}
</style>
